module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by Scott Hanzelka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("1. Texas: No Leisure on the New Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_vm._v("2. The Civil War, Reconstruction and Baseball: Division and Diversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Professional Baseball: Faith and Failure in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sherman, Denison and the Fenceless Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. 1895: The Texas League’s First Foray into a Second-Tier City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. 1896: A Rivalry Cut Short")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Paris: Stepping up to Save the Circuit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. 1897: The Increasing Railroad Influence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. 1902: The Interurban and a Team for the Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. 1903: Competitive Balance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. 1904: Small Cities Sandwich the League")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. 1905: A Shorter Jump")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. 1906: New Cities, New Legends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. 1907: The Small Market’s Last Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/after",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0